import {InjectionToken} from '@angular/core';

export const ApiClientConfig = new InjectionToken<ApiClientConfig>('ApiClientConfig');

export type AppId = 'primatoo-ui' | 'primatoo-ui-console';
export interface ApiClientConfig {
  endPoint: string;
  env: any;
  oauth: {
    spDomain: string;
    // clientId: string;
    // clientLoginPath: string;
    // clientLogoutPath: string;
  };
}

